__turbopack_context__.v({
  "critical": "_42nAha_critical",
  "high": "_42nAha_high",
  "low": "_42nAha_low",
  "mark": "_42nAha_mark",
  "medium": "_42nAha_medium",
  "meter": "_42nAha_meter",
  "off": "_42nAha_off",
  "on": "_42nAha_on",
});
